import React from 'react';
import { useId } from '@reach/auto-id';
import { DateRangePicker } from '../../../CommonComponents/OPL/dates/DateRangePicker/DateRangePicker';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import { Label } from '../../../CommonComponents/OPL/Label/Label';
import {
  PortfolioReportParam,
  usePortfolioReportCache,
} from '../../api/usePortfolioReportParamsQuery';
import { MarginProps } from '../../../theme/styledProps';
import { useDateRangePickerWithPresets } from './useDateRangePickerWithPresets';
import { dateToString } from '../../utils/dates';

interface Props extends MarginProps {
  param: PortfolioReportParam;
}

export const DateRangePickerWithPresets: React.FC<Props> = ({ param, ...rest }) => {
  const { range, minDate, rangePresets, customPeriodEnabled } = useDateRangePickerWithPresets({
    param,
  });

  const { mutateParamCache } = usePortfolioReportCache();
  const id = `input--${useId(param.displayName)}`;

  return (
    <Wrapper {...rest}>
      {param.displayName && (
        <Label htmlFor={id} mb="4" css="display: block">
          {param.displayName}
        </Label>
      )}

      <DateRangePicker
        id={id}
        range={range}
        onChange={_range => {
          mutateParamCache(param.id, {
            values: [dateToString(_range.dates[0]), dateToString(_range.dates[1])],
            range: _range,
          });
        }}
        presets={rangePresets}
        minDate={minDate}
        maxDate={new Date()}
        isReadonly={!customPeriodEnabled}
      />
    </Wrapper>
  );
};
